var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7398 5.68699L1.7998 4.74033C1.1998 5.51366 0.826468 6.40699 0.713135 7.33366H2.0598C2.15313 6.75366 2.38647 6.18699 2.7398 5.68699ZM2.0598 8.66699H0.713135C0.826468 9.59366 1.19313 10.487 1.79313 11.2603L2.73313 10.3137C2.38647 9.81366 2.15313 9.25366 2.0598 8.66699ZM2.73313 12.2137C3.50647 12.8137 4.40647 13.1737 5.33313 13.287V11.9337C4.75313 11.8337 4.19313 11.607 3.69313 11.247L2.73313 12.2137ZM6.66647 2.71366V0.666992L3.63313 3.70033L6.66647 6.66699V4.06033C8.5598 4.38033 9.9998 6.02033 9.9998 8.00033C9.9998 9.98032 8.5598 11.6203 6.66647 11.9403V13.287C9.2998 12.9603 11.3331 10.7203 11.3331 8.00033C11.3331 5.28033 9.2998 3.04033 6.66647 2.71366Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshImg);
export default __webpack_public_path__ + "static/media/refresh-img.c6ae650b8d7862536834bcbc407b391d.svg";
export { ForwardRef as ReactComponent };